import { render, staticRenderFns } from "./DocView.vue?vue&type=template&id=4dfd9b38&scoped=true"
import script from "./DocView.vue?vue&type=script&lang=js"
export * from "./DocView.vue?vue&type=script&lang=js"
import style0 from "./DocView.vue?vue&type=style&index=0&id=4dfd9b38&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfd9b38",
  null
  
)

export default component.exports